import { memo } from 'react'
import { Text, VStack, Stack } from '@chakra-ui/react'

import { CloudUpload } from 'components/icons'
import { useUploadImage } from '../../context/Provider'
import { callbackOnPressKey } from 'utils/events'

function ImageCard() {
  const { size, rounded, openModal } = useUploadImage()

  return (
    <Stack
      onClick={openModal}
      onKeyUp={(event) => callbackOnPressKey(event, openModal)}
      width={size}
      height={size}
      tabIndex={0}
      p={1}
      className="accessible"
      border="1px dashed"
      borderColor="borderColor"
      bg="light"
      align="center"
      justify="center"
      rounded={rounded}
      _hover={{
        color: 'primary',
        borderColor: 'primary',
        bg: 'lighterPrimary',
      }}
    >
      <VStack spacing={1}>
        <CloudUpload />
        <Text>Enviar foto</Text>
      </VStack>
    </Stack>
  )
}

export default memo(ImageCard)
